
import { useEffect, useState } from "react";

export default function useGoogleReviews() {
  const [state, setState] = useState({
    status: "loading",
    data: null,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();

    const API_BASE = import.meta.env.VITE_REVIEWS_API_BASE_URL || "";

fetch(`${API_BASE}/api/google-reviews`, {
  signal: controller.signal,
})
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed: ${response.status}`);
        }

        return response.json();
      })
      .then((data) => {
        setState({
          status: "ready",
          data,
          error: null,
        });
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          setState({
            status: "error",
            data: null,
            error: error.message,
          });
        }
      });

    return () => controller.abort();
  }, []);

  return state;
}
